export let menu = {
  namespaced:true,
  state:{
    firstClassInfo:{}  //主菜单相关
  },
  getters: {
    firstClassInfo: state => state.firstClassInfo,
  },
  mutations: {
    setFirstClass(state, data) {
      state.firstClassInfo = data
    },
  },
  actions: {
    actionFirstClass({ commit,getters},data) {
      commit('setFirstClass',data)
    }
  }
}
